import axios from 'axios';
import { environment } from '../shared/enviroment/environment';

export interface FbtMappingDto {
  _id: string;
  parentCategoryId: string;
  subCategoryId: string;
  parentCategory?: { _id: string; name: string };
  subCategory?: { _id: string; name: string };
}

export class FbtMappingsApiService {
  async list(): Promise<FbtMappingDto[]> {
    try {
      const url = `${environment.api.apiRootServer}/products/fbt-mappings`;
      const resp = await axios.get<{ success: boolean; data: FbtMappingDto[] }>(url, {
        // No auth headers; avoid 401-triggered redirects
        headers: { 'Content-Type': 'application/json' },
      });
      return resp.data?.data || [];
    } catch {
      return [];
    }
  }
}

export const fbtMappingsApi = new FbtMappingsApiService();
